import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Nav extends Component
{

	constructor ( props )
	{
		super( props );
		this.props = props;
	}

	renderItems = () =>
	{
		return this.props.urls.map( ( item, index ) => (
			<Link key={index} className={"breadcrumb-item-style " + item.class} to={{
				pathname : item.link
			}}>
				<li aria-current="page">{item.name}</li>
			</Link>
		) );
	};

	render ()
	{
		return (
			<nav className="location-nav" aria-label="breadcrumb">
				<Link className="brand-title" to={{
					pathname : `/`
				}}>
					بنیاد معارف شفاء
				</Link>
				<ol className="breadcrumb breadcrumb-style">
					{this.renderItems()}
				</ol>
			</nav>
		);
	}
}

export default Nav;
